exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "footer{margin-top:-25px;padding-top:25px;padding-bottom:25px;min-width:100%;background:url(/ng/assets/images/old/footer_bottom_bg.png);position:relative}footer ul{width:160px;vertical-align:top}footer ul li{border-bottom:1px dashed #aaa;height:18px;padding:5px 0;font-size:12px}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/core/footer/footer.component.css"],"names":[],"mappings":"AAAA,OACE,iBAAkB,iBACA,oBACG,eACL,2DAC2C,iBACxC,CACpB,UAGU,YAAa,kBAAoB,CAAC,aAE3C,8BAA+B,YAChB,cACC,cACC,CAClB","file":"footer.component.css","sourcesContent":["footer {\n  margin-top: -25px;\n  padding-top: 25px;\n  padding-bottom: 25px;\n  min-width:\t100%;\n  background: url('/assets/images/old/footer_bottom_bg.png');\n  position: relative;\n}\nfooter.haveFooter {\n}\nfooter ul {width: 160px; vertical-align: top}\nfooter ul li {\n  border-bottom:\t1px dashed #aaa;\n  height: \t\t18px;\n  padding:\t\t5px 0;\n  font-size:\t\t12px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/footer/footer.component.css
// module id = PZEB
// module chunks = 6